import { useTranslation } from 'react-i18next';

import { CustomModal, CustomModalProps } from '../shared';

import styles from './CancelPalletReportModal.module.css';

type DeleteStorageModalProps = CustomModalProps & {
   onAcceptClick: () => void;
   loading: boolean;
};

const CancelPalletReportModal = ({
   onClose,
   opened,
   loading,
   onAcceptClick,
}: DeleteStorageModalProps) => {
   const { t } = useTranslation();

   return (
      <CustomModal
         icon="ALERT_TRIANGLE"
         innerTitle={t('cancel_pallet_report_modal.title')}
         onClose={onClose}
         opened={opened}
         isLoading={loading}
         modalContentClassName={styles.modalContent}
         primaryButtonProps={{
            text: t('cancel_pallet_report_modal.title'),
            variant: 'filled-danger',
            onClick: onAcceptClick,
         }}
         secondaryButtonProps={{
            text: t('cancel_pallet_report_modal.back'),
            variant: 'outlined-danger',
            onClick: onClose,
         }}
      >
         <div className={styles.descriptionContainer}>
            <p className={styles.plainText}>{t('cancel_pallet_report_modal.question')}</p>
            <p className={styles.boldBlackText}>{t('cancel_pallet_report_modal.irreversible')}</p>
            <p className={styles.boldRedText}>
               {t('cancel_pallet_report_modal.transfer_to_balance')}
            </p>
         </div>
      </CustomModal>
   );
};

export default CancelPalletReportModal;
